export function initializeTypewriterEffect() {
  const typedText = document.querySelector(".typed-text");
  if (!typedText) return;

  // Read phrases directly from data attribute
  let phrases = [];

  try {
    phrases = JSON.parse(typedText.dataset.phrases || '[]');
  } catch (e) {
    console.warn('[Typewriter] Could not parse phrases:', e);
    return;
  }

  if (!phrases.length) return;

  let phraseIndex = 0;
  let charIndex   = 0;
  let isDeleting  = false;

  function type() {
    const currentPhrase = phrases[phraseIndex];
    typedText.textContent = currentPhrase.substring(0, charIndex);

    let delay = isDeleting ? 60 : 200;

    if (!isDeleting && charIndex < currentPhrase.length) {
      charIndex++;
    } else if (isDeleting && charIndex > 0) {
      charIndex--;
    } else {
      isDeleting = !isDeleting;
      if (!isDeleting) {
        phraseIndex = (phraseIndex + 1) % phrases.length;
      }
      delay = 1000;
    }

    setTimeout(type, delay);
  }

  if (!typedText.dataset.typingInit) {
    typedText.dataset.typingInit = "true";
    type();
  }
}